import type { Decoder } from 'io-ts/Decoder';
import { array, intersect, literal, nullable, number, struct, tuple, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Client, ClientType, Country, Organization, RequirementsJoined } from '../filter-request';

const withField = <Field extends string, A>(
	field: Field,
	decoder: Decoder<unknown, A>
): Decoder<unknown, { field: Field } & A> => intersect(decoder)(struct({ field: literal(field) }));

export const FilterRequest = array(
	union(
		withField('country', Country),
		// org
		withField('organization', Organization),
		// clientType
		withField('clientType', ClientType),
		// client
		withField('client', Client),
		withField('transactionRequirementJoined', RequirementsJoined),
		intersect(
			struct({
				field: literal('sentAt'),
			})
		)(
			union(
				struct({
					rangeType: literal('between'),
					values: tuple(iotsUtils.ValidDate, nullable(iotsUtils.ValidDate)),
				}),
				struct({
					rangeType: literal('past'),
					amount: number,
					metric: union(
						literal('days'),
						literal('weeks'),
						literal('months'),
						literal('calendar-month')
					),
				})
			)
		)
	)
);
